import React, { useEffect } from 'react';
import { Grid, Box, Typography, Skeleton } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { getTotalPhysicians } from '../../../../redux/thunks/physicanTargetListAnalysisThunk';
import { getPhysiciansList } from '../../../../redux/thunks/physiciansThunk';

function MatchRates() {
    const dispatch = useDispatch();
    const { company } = useSelector(state => state.company);
    const { isLoading, matchRate } = useSelector(state => state.physicianTargetListAnalysis);
    const { totalPhysicians } = useSelector(state => state.physician); // need to update
    useEffect(() => {
        if(company.id){
            dispatch(getTotalPhysicians({ companyId: company.id }));
            dispatch(getPhysiciansList({
                companyId: company.id, position: 0, page_size: 50, type: 'table' 
            }));
        }
    },[company.id]);

    return (
        <Box>
            <Box className="pb-20px">
                <Typography className="display-xs-medium gray-900">
                Match Rates
                </Typography>
            </Box>
            <Grid container className="flex-row" spacing={'24px'}> 
                {/* Total Physicians */}
                <Grid item xs={3}>
                    <Box className="padding-24px bg-primary-50 br-16px gap-8">
                        <Box className="flex-row-space-between-center gap-8">
                            <Typography className="text-sm-medium gray-500">
                            Total Physicians 
                            </Typography>
                        </Box>
                        <Box>
                            {
                                isLoading ? <Skeleton height={30} variant='text' width={200} /> :
                                    <Typography className="display-sm-semi-bold gray-900">
                                        {totalPhysicians}
                                    </Typography>
                            }

                        </Box>
                    </Box>
                </Grid>
                {/* Overall Match Rate */}
                <Grid item xs={3}>
                    <Box className="padding-24px bg-primary-50 br-16px gap-8">
                        <Box className="flex-row-space-between-center gap-8">
                            <Typography className="text-sm-medium gray-500">
                            Overall Match Rate
                            </Typography>
                        </Box>
                        <Box>
                            {
                                isLoading ? <Skeleton height={30} variant='text' width={100} /> :
                                    <Typography className="display-sm-semi-bold gray-900">
                                        {Number(matchRate)?.toFixed(2)}%
                                    </Typography>
                            }
                        </Box>
                    </Box>
                </Grid>
            
            </Grid>
        </Box>
    );
}

export default MatchRates;